import React, { useState, useEffect, useRef } from 'react';
import styles from './index.module.css';

const CONFIRM_SECONDS = 20;

const Index = ({
  handleSubmitRequest,
  setIsOpenName,
  setGuests,
  isActive,
  isActive_,
  setIsActive_,
  setIsActive,
  disabled = false,
  isPaymentPending = false
}) => {
  const [countdown, setCountdown] = useState(10);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmCountdown, setConfirmCountdown] = useState(CONFIRM_SECONDS);
  const inactivityTimer = useRef(null);
  const countdownTimer = useRef(null);
  const confirmTimer = useRef(null);
  const disabledRef = useRef(disabled);
  const isPaymentPendingRef = useRef(isPaymentPending);
  // Пока показан диалог подтверждения — общая активность (движение мыши/тап)
  // не должна молча его закрывать, ответ должен быть явным (кнопка)
  const showConfirmRef = useRef(false);
  const handleSubmitRequestRef = useRef(handleSubmitRequest);
  handleSubmitRequestRef.current = handleSubmitRequest;

  useEffect(() => {
    isPaymentPendingRef.current = isPaymentPending;
  }, [isPaymentPending]);

  const clearConfirmTimer = () => {
    if (confirmTimer.current) {
      clearInterval(confirmTimer.current);
      confirmTimer.current = null;
    }
  };

  const closeConfirm = () => {
    clearConfirmTimer();
    showConfirmRef.current = false;
    setShowConfirm(false);
  };

  // Обновляем ref при изменении disabled
  useEffect(() => {
    disabledRef.current = disabled;

    // Останавливаем все таймеры когда disabled
    if (disabled) {
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
        inactivityTimer.current = null;
      }
      if (countdownTimer.current) {
        clearInterval(countdownTimer.current);
        countdownTimer.current = null;
      }
      closeConfirm();
      setIsActive(true);
      setCountdown(10);
    }
  }, [disabled, setIsActive]);

  // Функция сброса таймера активности
  const resetTimer = () => {
    if (disabledRef.current) return;
    if (showConfirmRef.current) return;

    setIsActive(true);
    setCountdown(10);

    if (countdownTimer.current) {
      clearInterval(countdownTimer.current);
      countdownTimer.current = null;
    }

    if (inactivityTimer.current) {
      clearTimeout(inactivityTimer.current);
    }

    inactivityTimer.current = setTimeout(() => {
      if (disabledRef.current) return;
      setIsActive(false);
      startCountdown();
    }, 30000);
  };

  // Пока идёт оплата по QR, по истечению таймера не отменяем заказ вслепую —
  // сперва спрашиваем гостя, продолжает ли он оплату (заказ мог быть уже оплачен),
  // и только при явном отказе или отсутствии ответа отправляем отмену
  const startPaymentConfirm = () => {
    if (disabledRef.current) return;

    showConfirmRef.current = true;
    setShowConfirm(true);
    setConfirmCountdown(CONFIRM_SECONDS);

    clearConfirmTimer();
    confirmTimer.current = setInterval(() => {
      setConfirmCountdown((prev) => {
        if (prev === 1) {
          clearInterval(confirmTimer.current);
          confirmTimer.current = null;
          showConfirmRef.current = false;
          setShowConfirm(false);
          handleSubmitRequestRef.current('cancel');
          setIsOpenName(false);
          setGuests('');
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleConfirmContinue = () => {
    closeConfirm();
    // Гость подтвердил, что продолжает — перезапускаем обычный цикл ожидания активности,
    // вопрос будет показан снова после следующего периода бездействия
    resetTimer();
  };

  const handleConfirmCancel = () => {
    closeConfirm();
    handleSubmitRequestRef.current('cancel');
    setIsOpenName(false);
    setGuests('');
  };

  // Функция для начала отсчета при отсутствии активности
  const startCountdown = () => {
    if (disabledRef.current) return;

    setCountdown(10);

    if (countdownTimer.current) {
      clearInterval(countdownTimer.current);
    }

    countdownTimer.current = setInterval(() => {
      if (disabledRef.current) {
        clearInterval(countdownTimer.current);
        return;
      }

      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(countdownTimer.current);
          if (isPaymentPendingRef.current) {
            startPaymentConfirm();
          } else {
            setIsActive(false);
            handleSubmitRequestRef.current('cancel');
            setIsOpenName(false);
            setGuests('');
          }
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Эффект для отслеживания активности
  useEffect(() => {
    const handleActivity = () => {
      resetTimer();
    };

    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
    window.addEventListener('click', handleActivity);

    resetTimer();

    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      window.removeEventListener('click', handleActivity);
      if (inactivityTimer.current) {
        clearTimeout(inactivityTimer.current);
      }
      if (countdownTimer.current) {
        clearInterval(countdownTimer.current);
      }
      clearConfirmTimer();
    };
  }, []);

  // Не показываем таймер если disabled
  if (disabled) return null;

  return (
    <>
      {!isActive && countdown > 0 && !showConfirm && (
        <div className={styles.wrapper}>
          <p className={styles.timer}>{countdown}</p>
        </div>
      )}

      {showConfirm && (
        <div className={styles.wrapper}>
          <div className={styles.confirmBox}>
            <p className={styles.confirmText}>Вы продолжаете оплату заказа?</p>
            <p className={styles.confirmHint}>
              Если не ответить, заказ будет отменён через {confirmCountdown} сек.
            </p>
            <div className={styles.confirmActions}>
              <button type="button" className={styles.confirmYes} onClick={handleConfirmContinue}>
                Да, продолжаю
              </button>
              <button type="button" className={styles.confirmNo} onClick={handleConfirmCancel}>
                Нет, отменить
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Index;
